import { createFileRoute, Outlet } from '@tanstack/react-router';

import { requirePermission } from '@/lib/guards';

/**
 * Layout route for /exercises/:id/*. Renders <Outlet /> so child routes
 * (`/` index = detail screen, `/edit` = edit form) appear here.
 *
 * If this returned the detail screen directly, the edit child would have
 * nowhere to render and clicking "Edit" would silently fail (the URL
 * changes to /edit but the detail screen keeps rendering). Mirrors the
 * same layout/index split used in `practitioners/$practitionerId.tsx`
 * and `engagement/resources/$id.tsx`.
 */
export const Route = createFileRoute('/_staff/admin/workspace/exercises/$id')({
  beforeLoad: () => {
    requirePermission('engagement:read');
  },
  component: WorkspaceExerciseLayout,
  staticData: { crumb: 'Exercise' },
});

function WorkspaceExerciseLayout() {
  return <Outlet />;
}
